export default {
  FETCHING: 'pagination/fetching',
  FULFILLED: 'pagination/fulfilled',
  REJECTED: 'pagination/rejected',
  CLEAR: 'pagination/clear',
  CANCEl: 'pagination/cancel',
}
